import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Table = ({ bufferFeatures, bufferDataOne, bufferLayer }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [propertiesData, setPropertiesData] = useState(1);
  const [processedIds, setProcessedIds] = useState(new Set());
  const { isTheme } = useSelector((state) => state.currentStage);
  const [isFetching, setIsFetching] = useState(false)
  const rowsPerPage = 10;



  useEffect(() => {
    setPropertiesData(bufferDataOne)
  }, [bufferDataOne])


  const safeBufferDataOne = Array.isArray(propertiesData) ? propertiesData : [];
  const safeBufferFeatures = Array.isArray(bufferFeatures) ? bufferFeatures : [];


  const showBufferDataOneTable = bufferLayer === "Properties";




  const filteredBufferDataOne = showBufferDataOneTable ? safeBufferDataOne : [];




  const bufferDataOneColumns = Array.from(
    new Set(filteredBufferDataOne.flatMap((item) => Object.keys(item)))
  );
  const bufferFeaturesColumns = Array.from(
    new Set(safeBufferFeatures.flatMap((item) => Object.keys(item)))
  ).filter((col) => col !== "relation_id");


  const hasRelationId = safeBufferDataOne.some((item) => item.relation_id);
  const showBufferFeaturesTable = !(bufferLayer === "Properties" && hasRelationId);




  const totalPagesOne = Math.ceil(filteredBufferDataOne.length / rowsPerPage);
  const totalPagesTwo = Math.ceil(safeBufferFeatures.length / rowsPerPage);
  const startIndexOne = (currentPage - 1) * rowsPerPage;
  const startIndexTwo = (currentPage - 1) * rowsPerPage;
  const currentRowsOne = filteredBufferDataOne.slice(startIndexOne, startIndexOne + rowsPerPage);
  const currentRowsTwo = safeBufferFeatures.slice(startIndexTwo, startIndexTwo + rowsPerPage);

  const goToNextPage = async () => {
    setCurrentPage((prev) => prev + 1);

    // if (bufferLayer === "Properties") {
    //   if (isFetching) return;
    //   setIsFetching(true);

    //   const relationIds1 = JSON.parse(localStorage.getItem("relationIds") || "[]")
    //     .map(id => id.replace(/^'|'$/g, ""))

    //   const selectedUlb = localStorage.getItem("selectedUlb")
    //   const unprocessedIds = relationIds1.filter(id => !processedIds.has(id));


    //   if (unprocessedIds.length === 0) {
    //     console.log("All relation IDs have been processed. No more API calls.");
    //     setIsFetching(false);
    //     return;
    //   }
    //   const idsToProcess = unprocessedIds.slice(0, 100);
    //   const relationIds = idsToProcess.map(id => `'${id.trim()}'`).join(",");
    //   if (relationIds) {
    //     const updateData = await getNewTableData(relationIds, selectedUlb);
    //     setPropertiesData(prevData => {
    //       const safePrevData = Array.isArray(prevData) ? prevData : [];
    //       return [...safePrevData, ...updateData]; 
    //     });
    //     setProcessedIds(prev => new Set([...prev, ...idsToProcess]));
    //     setIsFetching(false);
    //   } else {
    //     console.log("No valid relation IDs to fetch data.");
    //     setIsFetching(false);
    //   }
    // }
  };


  const getNewTableData = async (relationIds, selectedUlb) => {
    if (!relationIds || !selectedUlb) {
      console.log("No relationIds or selectedUlb provided!");
      return [];
    }
    try {
      const encodedIds = encodeURIComponent(`${relationIds}`);
      const encodedUlb = encodeURIComponent(selectedUlb);
      const apiUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd%3D%27${encodedUlb}%27+and+relation_id+in+%28${encodedIds}%29&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=pjson`

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();


      return data.features?.map(f => f.attributes) || [];
    } catch (error) {
      console.log("Error fetching data:", error);
      return [];
    }
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }



  const goToPreviousPage = () => {
    setCurrentPage((prev) => prev - 1);
  };



  const allowedFieldsLandmark = ["ulbcode", "wardno", "latitude", "longitude", "name", "type"];
  const allowedFieldsPlot = ["parcelno", "area", "wardno"];
  const filteredColumns = bufferFeaturesColumns.filter(field =>
    bufferLayer === "Important Land Marks"
      ? allowedFieldsLandmark.includes(field)
      : bufferLayer === "Plot Building Structure" ? allowedFieldsPlot.includes(field) : true
  );

  return (
    <>

      {/* Table 1: Buffer Data One (if conditions met) */}
      {/* {showBufferDataOneTable && filteredBufferDataOne.length > 0 && (
        <div className="table-responsive">
          <table className="table table-dark-security caption-top manage-user-table">
            <thead>
              <tr>
                {bufferDataOneColumns.map((field, idx) => (
                  <th key={idx}>{field === "area" ? "Area (sqft)" : field}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentRowsOne.map((detail, idx) => (
                <tr key={idx}>
                  {bufferDataOneColumns.map((key, colIdx) => (
                    <td key={`${idx}-${colIdx}`} className="text-white">
                      {detail[key]?.toString().trim() || "-"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

      {showBufferDataOneTable && filteredBufferDataOne.length > 0 && (
        <div className="table-responsive">
          <table className="table table-dark-security caption-top manage-user-table">
            <thead>
              <tr>
                {/* {bufferDataOneColumns.map((field, idx) => {
                  console.log("fieldfield", field); // ✅ Correct placement of console.log()
                  return <th key={idx}>{field === "area" ? "Area (sqft)" : field}</th>;
                  
                })} */}
                <th>Gis UniqueId</th>
                <th>E-nagarpalikaid</th>
                <th>Owner Name</th>
                <th>No of floor</th>
                <th>Area(sqrft)</th>
                <th>Ward No</th>
                <th>Phone No</th>
                <th>Property Type</th>
              </tr>
            </thead>
            <tbody>
              {currentRowsOne.map((detail, idx) => (
                // <tr key={idx}>
                //   {bufferDataOneColumns.map((key, colIdx) => (
                //     <td key={${idx}-${colIdx}}>
                //       {feature[key]?.toString().trim() || "-"}
                //     </td>
                //   ))}
                // </tr>
                <tr key={idx}>
                  <td>{detail.gis_uniqueid}</td>
                  <td>{detail.e_nagarpalikaid}</td>
                  <td>{detail.ownername}</td>
                  <td>{detail.nooffloor}</td>
                  <td>{Number(detail.plotsize).toFixed(2)}</td>
                  <td>{detail.wardno}</td>
                  <td>{detail.mobileno}</td>
                  <td>
                    {detail.isuseres === "Yes"
                      ? "Residential"
                      : detail.isuseres === "No"
                        ? "Commercial"
                        : detail.isuseres === "Mix Use"
                          ? "Both"
                          : "Unknown"}
                  </td>



                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Table 2: Buffer Features (Hide when bufferLayer="Properties" & relation_id exists) */}
      {showBufferFeaturesTable && safeBufferFeatures.length > 0 && (
        <div className="table-responsive">
          <table className="table table-dark-security caption-top manage-user-table">
            <thead>
              <tr>
                {filteredColumns.flatMap((field, idx) => {
                  if (field === "wardno") {
                    return <th key={idx}>Ward No</th>;
                  } else if (field === "area") {
                    return [
                      <th key={`${idx}-area`}>Area (sqft)</th>,
                    ];
                  } else if (field === "parcelno") {
                    return [
                      <th key={idx}>Parcel No</th>,
                    ];
                  } else if (field === "ulbcode") {
                    return [
                      <th key={idx}>Ulb Code</th>,
                    ];
                  } else {
                    return <th key={idx}>{capitalizeFirstLetter(field)}</th>;
                  }
                })}

              </tr>
            </thead>
            <tbody>
             {currentRowsTwo.map((feature, idx) => (
                <tr key={idx}>
                  {/* {filteredColumns.map((key, colIdx) => (
                    <td key={`${idx}-${colIdx}`}>
                      {feature[key]?.toString().trim() || "-"}
                    </td>
                  ))} */}
                  {filteredColumns.map((key, colIdx) => (
                    <td key={`${idx}-${colIdx}`}>
                      {key === "area"
                        ? parseFloat(feature[key]).toFixed(2)
                        : feature[key]?.toString().trim() || "-"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}


      {/* Pagination Controls */}
      <div className="paginationdiv">
        <div>
          <span style={{ fontSize: "14px", color: "white" }}>
            Showing {rowsPerPage} rows per page
          </span>
        </div>
        <div className="rightsidepagination">
          <span style={{ fontSize: "14px", color: "white" }}>
            Page {currentPage} of {Math.max(totalPagesOne, totalPagesTwo)}
          </span>
          <button
            className="btn btn-secondary"
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          <button
            className="btn btn-secondary"
            onClick={goToNextPage}
            disabled={currentPage >= Math.max(totalPagesOne, totalPagesTwo)}
          >
            &gt;
          </button>
        </div>
      </div>
    </>
  );
};

export default Table;
